module.exports = __webpack_public_path__ + "img/Flecha-Derecha.93e576bf.png";